import ApiService from "../api";

export default class PagamentoCompensadaService extends ApiService {

    constructor() {
        super("/api/pagamento-compensada");
    }

    getColunasConfig() {
        return this.get("/colunas-config");
    }

    salvarColunasConfig(dto) {
        return this.put("/colunas-config", dto);
    }

    lerCabecalho(file) {
        const formData = new FormData();
        formData.append("file", file);
        return this.post("/cabecalho", formData);
    }

    preview(file, mapeamento) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("mapeamento", JSON.stringify(mapeamento));
        return this.post("/preview", formData);
    }

    confirmar(file, mapeamento, ignorarSemFilial) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("mapeamento", JSON.stringify(mapeamento));
        formData.append("ignorarSemFilial", !!ignorarSemFilial);
        return this.post("/confirmar", formData);
    }

    resumoCalendario(ano, mes) {
        return this.get(`/calendario/resumo?ano=${ano}&mes=${mes}`);
    }

    detalheDia(data) {
        return this.get(`/calendario/dia?data=${data}`);
    }

    historico() {
        return this.get("/historico");
    }

    confronto(filtros) {
        const params = new URLSearchParams();
        Object.entries(filtros || {}).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") {
                params.append(chave, valor);
            }
        });
        return this.get(`/confronto?${params.toString()}`);
    }

    salvarAjusteManualCte(dto) {
        return this.post("/cte-ajuste-manual", dto);
    }

    removerAjusteManualCte(filialId, numeroCte, numeroSerie) {
        const params = new URLSearchParams({ filialId, numeroCte });
        if (numeroSerie) params.append("numeroSerie", numeroSerie);
        return this.delete(`/cte-ajuste-manual?${params.toString()}`);
    }

    confrontoDashboard(filtros) {
        const params = new URLSearchParams();
        Object.entries(filtros || {}).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") {
                params.append(chave, valor);
            }
        });
        return this.get(`/confronto/dashboard?${params.toString()}`);
    }

    confrontoDashboardDetalhe(filtros) {
        const params = new URLSearchParams();
        Object.entries(filtros || {}).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") {
                params.append(chave, valor);
            }
        });
        return this.get(`/confronto/dashboard/detalhe?${params.toString()}`);
    }
}
